module.exports = __webpack_public_path__ + "static/media/rebirth_23.2f7ed25f.jpg";